<template>
    <div class="model-action">
        <div
            v-if="!isAddingNewCode"
            class="model-action__button"
            @click="showForm"
        >
            <img v-svg-inline src="@/assets/icons/ui/plus.svg" />

            <div class="model-action__label">Добавить еще код модели</div>
        </div>

        <div
            v-else
            class="model-action__form"
        >
            <div class="model-action__form-row">
                <UIInput
                    id="dealerName"
                    v-model="form.model_code"
                    label="Код модели*"
                    :error-message="errors.model_code?.join() ?? ''"
                />

                <UISelect
                    id="localProductionStartYear"
                    v-model="form.production_start_year"
                    :options="modelCodeProductionYearsOptions"
                    label="Год начала производства*"
                    :error-message="errors.production_start_year?.join() ?? ''"
                />

                <UISelect
                    id="localProductionEndYear"
                    v-model="form.production_end_year"
                    :options="modelCodeProductionYearsOptions"
                    label="Год окончания производства"
                    :error-message="errors.production_end_year?.join() ?? ''"
                />
            </div>

            <div class="model-action__form-row">
                <div class="add-model-code__actions">
                    <UISimpleButton @clicked="handleAddModelCode">
                        Добавить код модели
                    </UISimpleButton>

                    <UISimpleButton
                        button-type="outlined"
                        @clicked="closeForm"
                    >
                        Отменить
                    </UISimpleButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';

    import { SelectOption } from '@/types/form.type.ts';
    import {
        ModelCodeMinProductionYear,
        ModelCodeMaxProductionYear,
        ModelCodeCreateForm,
        ModelCodeCreateFormErrors,
    } from '@/types/model-code.type.ts';

    import { range } from '@/utils/collection-helpers.ts';

    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISelect from '@/components/ui/UISelect/UISelect.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const emits = defineEmits<{
        (e: 'addModelCode', payload: ModelCodeCreateForm): void,
    }>();

    const isAddingNewCode = ref(false);
    const form = ref<ModelCodeCreateForm>({
        model_code: '',
        production_start_year: undefined,
        production_end_year: undefined,
    });
    const errors = ref<ModelCodeCreateFormErrors>({});

    const modelCodeProductionYears: Array<number> = range(ModelCodeMaxProductionYear, ModelCodeMinProductionYear, -1);
    const modelCodeProductionYearsOptions: SelectOption[] = modelCodeProductionYears.map((year: number) => {
        const selectOption: SelectOption = {
            label: year,
            value: year,
        };

        return selectOption;
    });

    function showForm(): void {
        isAddingNewCode.value = true;
    }

    function closeForm(): void {
        isAddingNewCode.value = false;
        form.value = {
            model_code: '',
            production_start_year: undefined,
            production_end_year: undefined,
        };
        errors.value = {};
    }

    function handleAddModelCode(): void {
        if (!validate()) {
            return;
        }

        emits('addModelCode', { ...form.value });

        closeForm();
    }

    function validate(): boolean {
        errors.value = {
            model_code: [],
            production_start_year: [],
        };

        if (form.value.model_code === undefined || form.value.model_code.length === 0) {
            errors.value.model_code?.push('Код модели обязателен к заполнению');
        }

        if (form.value.production_start_year === undefined) {
            errors.value.production_start_year?.push('Год начала производтсва обязателен к заполнению');
        }

        return !(errors.value.model_code?.length) && !(errors.value.production_start_year?.length);
    }
</script>

<style lang="scss" scoped>
    @use 'AddModelCodeAction' as *;
</style>
